import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPreGlobal, lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './Theme.styles.js';

var defaultProps = {
  look: "dark"
};

var getThemeChildrenClass = function getThemeChildrenClass(look, component) {
  var _a, _b, _c, _d;

  var whiteLabelLook = typeof window !== "undefined" && ((_b = (_a = window.lsgWL) === null || _a === void 0 ? void 0 : _a.componentMap) === null || _b === void 0 ? void 0 : _b[component]) || typeof window !== "undefined" && ((_d = (_c = window.lsgWL) === null || _c === void 0 ? void 0 : _c.themeMap) === null || _d === void 0 ? void 0 : _d[look]) || look;
  return "".concat(lsgPreGlobal, "theme__").concat(whiteLabelLook);
};

var getThemeClass = function getThemeClass(look, component) {
  var _a, _b, _c, _d;

  var whiteLabelLook = typeof window !== "undefined" && ((_b = (_a = window.lsgWL) === null || _a === void 0 ? void 0 : _a.componentMap) === null || _b === void 0 ? void 0 : _b[component]) || typeof window !== "undefined" && ((_d = (_c = window.lsgWL) === null || _c === void 0 ? void 0 : _c.themeMap) === null || _d === void 0 ? void 0 : _d[look]) || look;
  return "".concat(lsgPreGlobal, "theme__").concat(whiteLabelLook, " ").concat(lsgPreGlobal, "theme__bg-").concat(whiteLabelLook);
};

var ThemePresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      noMargin = props.noMargin,
      className = props.className,
      look = props.look,
      componentContext = props.componentContext,
      componentName = props.componentName;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__prevent-margin-overlap"), !componentContext), _defineProperty(_cleanupClassObject, getThemeClass(look, componentName), true), _cleanupClassObject)),
    role: "region"
  }, children);
}, defaultProps);

export { ThemePresentation, defaultProps, getThemeChildrenClass, getThemeClass };
